import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { PromoDiskButton } from 'components/no-auth/common/PromoDiskButton/PromoDiskButton';
import Auth from 'components/no-auth/header/Auth';
import LogoPurple from 'components/no-auth/header/LogoPurple';

import { toggleNavModal } from 'actions/appAction';

import {
    TopMenu,
    TabNameDesktop,
    TopMenuLink,
    ToggleNavModal,
    FlexPanel,
    HeaderDesktopContainer,
    HeaderDesktopContent,
    HeaderLogo,
    AuthWrapper,
    TopMenuIcon,
    HeaderDesktopLibre,
} from './styles';

const HeaderDesktop = (props) => {
    const location = useLocation();

    const linkIsSelected = (link) => link.nav_links.some((nl) => nl.url === location.pathname);
    const navLinkIsSelected = (navlink) => navlink.url === location.pathname;

    if (props.libre) {
        return (
            <HeaderDesktopLibre>
                <HeaderDesktopContent>
                    <FlexPanel>
                        <HeaderLogo>
                            <LogoPurple lang={props.lang} country={props.country} />
                        </HeaderLogo>
                    </FlexPanel>
                </HeaderDesktopContent>
            </HeaderDesktopLibre>
        );
    } else {
        return (
            <HeaderDesktopContainer>
                <HeaderDesktopContent>
                    <FlexPanel>
                        <LogoPurple lang={props.lang} country={props.country} />
                        <TopMenu>
                            {props.data &&
                                props.data
                                    .filter((item) => item !== null)
                                    .map((link) => {
                                        return (
                                            link.authorised_user === false && (
                                                <li key={link.id}>
                                                    <TabNameDesktop isSelected={linkIsSelected(link)} tabIndex={'0'}>
                                                        {link.title}
                                                    </TabNameDesktop>
                                                    <nav>
                                                        <ul>
                                                            {link.nav_links
                                                                .filter((item) => item !== null)
                                                                .map((navlink) => {
                                                                    return (
                                                                        <li key={navlink.id}>
                                                                            <TopMenuLink
                                                                                tabIndex={'0'}
                                                                                href={navlink.url}
                                                                                title={navlink.title}
                                                                                target={navlink.isBlank ? '_blank' : null}
                                                                                isSelected={navLinkIsSelected(navlink)}
                                                                            >
                                                                                {navlink?.icon?.url && (
                                                                                    <TopMenuIcon
                                                                                        src={navlink.icon?.url}
                                                                                        alt={navlink.title}
                                                                                        width={'24'}
                                                                                        height={'24'}
                                                                                    />
                                                                                )}
                                                                                {navlink.title}
                                                                            </TopMenuLink>
                                                                        </li>
                                                                    );
                                                                })}
                                                        </ul>
                                                    </nav>
                                                </li>
                                            )
                                        );
                                    })}
                        </TopMenu>
                        {props.authData && (
                            <AuthWrapper>
                                <Auth isLanding={props.isLanding} pageName={props.pageName} data={props.authData} />
                            </AuthWrapper>
                        )}

                        {!props.isShowNavModal ? (
                            <ToggleNavModal>
                                <PromoDiskButton
                                    type="button"
                                    iconName="burger"
                                    isNavButton
                                    labelText="Show navigation menu"
                                    onClick={() => props.toggleNavModal(true)}
                                    onKeyPress={() => props.toggleNavModal(true)}
                                    tabIndex={'0'}
                                />
                            </ToggleNavModal>
                        ) : (
                            <ToggleNavModal onClick={() => props.toggleNavModal(false)}>
                                <PromoDiskButton
                                    type="button"
                                    iconName="cross"
                                    isNavButton
                                    labelText="Close navigation menu"
                                    onClick={() => props.toggleNavModal(true)}
                                    onKeyPress={() => props.toggleNavModal(true)}
                                    tabIndex={'0'}
                                />
                            </ToggleNavModal>
                        )}
                    </FlexPanel>
                </HeaderDesktopContent>
            </HeaderDesktopContainer>
        );
    }
};
const mapStateToProps = (state) => {
    return {
        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,
        isShowNavModal: state.app.isShowNavModal,
    };
};
export default connect(mapStateToProps, { toggleNavModal })(HeaderDesktop);
